import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from 'src/services/firebase-config';

export const useGlobalConfig = () => {
  const [config, setConfig] = useState({
    showPromo: false,
    showMaintenance: false,
    promoMessage: '',
    promoMessageKeyWord: '',
    promoMessageKeyCode: '',
    promoInsertAfterWord: '',
    showAppReleasePromo: false,
    showAppReleasePromoAllUsers: false,
  });

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'zosa_setup', 'global_config'), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setConfig({
          showPromo: data.showPromo ?? false,
          showMaintenance: data.showMaintenance ?? false,
          promoMessage: data.promoMessage || '',
          promoMessageKeyWord: data.promoMessageKeyWord || '',
          promoMessageKeyCode: data.promoMessageKeyCode || '',
          promoInsertAfterWord: data.promoInsertAfterWord || '',
          showAppReleasePromo: data.showAppReleasePromo ?? false,
          showAppReleasePromoAllUsers: data.showAppReleasePromoAllUsers ?? false,
        });
      } else {
        setConfig(prev => ({ ...prev }));
      }
    }, (error) => {
      setConfig(prev => ({ ...prev }));
    });

    return () => unsub();
  }, []);

  return config;
};